'use client';

import { ExperienceMode } from '@/generated/graphql';
import { config } from '@/config/environment';
import type { HomepageContent } from '@/app/(site)/(home)/v2/lib/fetch-content';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { useSearchParams } from 'next/navigation';
import 'react-dates/initialize';
import ExploreContent from './components/explore-content';
import ExploreFilters from './components/explore-filters';
import ArchiveFeaturedExperiences from './components/archive-featured-experiences';

const MainDiv = styled.div`
  width: 100%;
  @media screen and (max-width: 768px) {
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }
`;
const Title = styled(Typography)`
  color: #251628;
  text-align: center;
  font-family: var(--font-cooper-light);
  font-size: 50px;
  font-style: normal;
  font-weight: 400;
  line-height: 112.3%; /* 56.15px */
  margin-bottom: 40px;
  padding-top: 90px;

  @media (max-width: 768px) {
    font-size: 50px;
    font-weight: 300;
    text-align: start;
  }
`;

const backgrounds = {
  [ExperienceMode.Online]: { background: 'linear-gradient(180deg, #BF9BB9 0%, #FFF3DC 100%)' },
  [ExperienceMode.InPerson]: {
    background:
      'linear-gradient(180deg, #1AA16B 0%, #D7E8C3 30.37%, #EAEDCF 49.46%, #FFF3DC 70.83%)',
  },
  all: { background: 'linear-gradient(180deg, #FFCF36 0%, #FFF3DC 100%)' },
};

interface ExploreProps {
  homepageContent?: HomepageContent;
}

const Explore = ({ homepageContent }: ExploreProps) => {
  const archiveMode = config.platformMode === 'archive';
  const router = useSearchParams();
  const mode = router?.get('mode') as ExperienceMode;

  if (archiveMode) {
    return (
      <MainDiv style={backgrounds['all']}>
        <Title>Past experiences</Title>
        <ArchiveFeaturedExperiences homepageContent={homepageContent} />
      </MainDiv>
    );
  }

  return (
    <MainDiv style={backgrounds[mode || 'all']}>
      <Title>Explore experiences</Title>
      <ExploreFilters />
      <ExploreContent />
    </MainDiv>
  );
};

export default Explore;
